import { render, staticRenderFns } from "./ServicoAtendimentoCadastroModal.vue?vue&type=template&id=254df3b9&scoped=true"
import script from "./ServicoAtendimentoCadastroModal.vue?vue&type=script&lang=js"
export * from "./ServicoAtendimentoCadastroModal.vue?vue&type=script&lang=js"
import style0 from "./ServicoAtendimentoCadastroModal.vue?vue&type=style&index=0&id=254df3b9&prod&scoped=true&lang=stylus"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "254df3b9",
  null
  
)

export default component.exports